export const Overline = ({ children, className = "" }) => (
    <div className={`text-xs uppercase tracking-[0.22em] font-semibold text-zinc-500 ${className}`}>
        {children}
    </div>
);

export const SectionHeader = ({ kicker, title, lead, align = "left" }) => {
    return (
        <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
            {kicker && <Overline className="mb-4">{kicker}</Overline>}
            <h2 className="font-display font-bold uppercase text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[#0A0A0A]">
                {title}
            </h2>
            {lead && <p className="mt-5 text-base sm:text-lg text-zinc-600 leading-relaxed">{lead}</p>}
        </div>
    );
};

export const Stat = ({ value, label }) => (
    <div className="border-l border-black/15 pl-4 py-1">
        <div className="font-display text-3xl sm:text-4xl font-bold tracking-tight">{value}</div>
        <div className="text-xs uppercase tracking-[0.18em] text-zinc-500 mt-1.5 font-semibold">{label}</div>
    </div>
);

export const FeatureCard = ({ icon: Icon, title, children, testId }) => (
    <div
        data-testid={testId}
        className="group bg-white border border-black/10 p-7 sm:p-8 hover:-translate-y-1 hover:border-black transition-all duration-200"
    >
        <div className="h-11 w-11 grid place-items-center bg-[#0A0A0A] text-white group-hover:bg-[#E63946] transition-colors">
            {Icon && <Icon className="h-5 w-5" strokeWidth={2.2} />}
        </div>
        <h3 className="mt-6 font-display font-bold text-lg sm:text-xl uppercase tracking-tight">{title}</h3>
        <p className="mt-3 text-sm sm:text-base text-zinc-600 leading-relaxed">{children}</p>
    </div>
);
